import { ApolloError, MutationFunction, useMutation } from '@apollo/client';

import { CreateEnterpriseDutchiePosLoyaltyMemberDocument } from 'src/gql/graphql';
import type {
  CreateEnterpriseDutchiePosLoyaltyMemberMutation,
  CreateEnterpriseDutchiePosLoyaltyMemberMutationVariables,
} from 'src/gql/graphql';

export type UseEnterpriseDutchieLoyaltyReturn = {
  createEnterpriseDutchiePosLoyaltyMember: MutationFunction<
    CreateEnterpriseDutchiePosLoyaltyMemberMutation,
    CreateEnterpriseDutchiePosLoyaltyMemberMutationVariables
  >;
  loading: boolean;
  error: ApolloError | undefined;
  called: boolean;
};

export default function useEnterpriseDutchieLoyalty(): UseEnterpriseDutchieLoyaltyReturn {
  const [createEnterpriseDutchiePosLoyaltyMember, { loading, error, called }] = useMutation(
    CreateEnterpriseDutchiePosLoyaltyMemberDocument
  );

  return {
    createEnterpriseDutchiePosLoyaltyMember,
    loading,
    error,
    called,
  };
}

export { useEnterpriseDutchieLoyalty };
